export default __webpack_public_path__ + "static/media/error-alert-icon.20754a58.svg";